import { DataResult, State, toDataSourceRequestString } from "@progress/kendo-data-query";
import axios from "axios";
import { showActionFailureToast } from "../../TransportNetwork/NotificationForActionButton";
import { emptyDataGridResult } from "./emptyDataGridResult";

const fetchGridData = (url: string, dataState: State) => {
  const queryParameters: string = toDataSourceRequestString(dataState);

  return axios
    .request({
      method: "POST",
      url: `${url}?${queryParameters}`,
    })
    .then((response) => response.data)
    .then((gridData) =>
      gridData === null
        ? emptyDataGridResult
        : ({
            data: gridData.Data,
            total: gridData.Total,
          } as DataResult)
    )
    .catch(() => {
      showActionFailureToast({ current: null }, "Error while fetching overview items");
      return emptyDataGridResult;
    });
};

export default fetchGridData;
